const token = localStorage.getItem('token') || '';
import env from "../enviroments/enviroment"

const getLogo = (id: number) => {
    return fetch(`${env.base_url}/partners/logo/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
}

export default getLogo;